/* An isolated desktop presentation; the original carousel still owns page intro. */
(() => {
  const media = matchMedia('(min-width:1201px)');
  function mount(section) {
    if (!media.matches || section._akShowcase) return;
    const template = section.querySelector('[data-ak-showcase-template]');
    if (!template) return;
    const view = template.content.firstElementChild.cloneNode(true);
    const track = template.parentElement;
    const originalCover = track.querySelector('.ak-carousel-image-cover');
    const nativeParts = [...section.querySelectorAll('.splide__list,.ak-slider-nav,.collection-carousel-controls,[data-ak-featured-explore-slide]')];
    const originalInert = nativeParts.map(element => element.inert);
    const cards = [...view.querySelectorAll('[data-ak-showcase-card]')];
    const captions = [...view.querySelectorAll('[data-ak-price-caption]')];
    const originalCoverRunning = section.dataset.akCoverRunning;
    const count = Math.ceil(cards.length / 4);
    const previous = view.querySelector('[data-ak-showcase-prev]');
    const next = view.querySelector('[data-ak-showcase-next]');
    const rowCovers = [...view.querySelectorAll('.ak-home-showcase__row-cover')];
    const explore = view.querySelector('.ak-home-showcase__explore-card');
    const exploreClasses = ['ak-featured-final-swap-active','ak-featured-final-swap-complete','ak-featured-explore-copy-ready'];
    const originalExploreClasses = exploreClasses.map(name => section.classList.contains(name));
    let page = 0, busy = false, disposed = false, exploreGeneration = 0;
    const timers = new Set();
    const later = (fn, ms) => { const id = setTimeout(() => { timers.delete(id); if (!disposed) fn(); }, ms); timers.add(id); };
    function render() {
      cards.forEach((card, i) => { card.hidden = Math.floor(i / 4) !== page; });
      previous.disabled = busy || page === 0;
      next.disabled = busy || page === count - 1;
      view.style.setProperty('--showcase-page', page);
      view.style.setProperty('--showcase-pages', count);
      view.querySelector('[data-ak-showcase-status]').textContent = `Page ${page + 1} of ${count}`;
    }
    function setDoors(state) {
      if (state === 'opening') view.dataset.akRotationRevealed = 'true';
      rowCovers.forEach(cover => {
        cover.classList.remove('ak-carousel-cover-closed','ak-carousel-cover-closing','ak-carousel-cover-opening');
        if (state) cover.classList.add(`ak-carousel-cover-${state}`);
      });
    }
    function mirrorDoors() {
      if (busy) return;
      const state = ['closed','closing','opening'].find(name => originalCover?.classList.contains(`ak-carousel-cover-${name}`));
      setDoors(state);
      // Revisited sections may already have completed their door entrance.
      if (!state) view.dataset.akRotationRevealed = 'true';
    }
    function clearExploreReveal() {
      window.clearTimeout(section.__akExploreCopyReadyTimer);
      if (section.__akExploreCopyReadyBox && section.__akExploreCopyReadyHandler) {
        section.__akExploreCopyReadyBox.removeEventListener('transitionend', section.__akExploreCopyReadyHandler);
      }
      section.__akExploreCopyReadyBox = null;
      section.__akExploreCopyReadyHandler = null;
    }
    function startExplore() {
      const generation = ++exploreGeneration;
      clearExploreReveal();
      exploreClasses.forEach(name => section.classList.remove(name));
      if (explore.hidden) return;
      // Match the native carousel's committed reset and two-frame handoff.
      void explore.offsetWidth;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (disposed || generation !== exploreGeneration || explore.hidden) return;
        window.AKCarouselExploreReveal(section, explore);
      }));
      later(() => {
        if (generation !== exploreGeneration || explore.hidden) return;
        section.classList.add('ak-featured-final-swap-complete');
      }, 900);
    }
    function doorDuration() {
      const reference = document.querySelector('section.ak-featured-carousel:not([data-ak-home-showcase]) .ak-carousel-image-cover-top');
      const value = reference ? getComputedStyle(reference).transitionDuration.split(',')[0].trim() : '450ms';
      const milliseconds = Number.parseFloat(value) * (value.endsWith('ms') ? 1 : 1000);
      const duration = milliseconds > 0 ? milliseconds : 450;
      view.style.setProperty('--showcase-door-duration', `${duration}ms`);
      return duration;
    }
    function change(delta) {
      if (busy || page + delta < 0 || page + delta >= count) return;
      busy = true;
      section.dataset.akCoverRunning = 'true';
      view.setAttribute('data-ak-showcase-paging','');
      const duration = doorDuration();
      setDoors('closing');
      captions.forEach(caption => caption.classList.add('ak-carousel-price-hidden'));
      render();
      later(() => {
        setDoors('closed');
        page += delta;
        render();
        later(() => {
          setDoors('opening');
          later(() => captions.forEach(caption => caption.classList.remove('ak-carousel-price-hidden')), 100);
          later(() => {
            setDoors();
            startExplore();
            busy = false;
            section.dataset.akCoverRunning = 'false';
            render();
          }, duration + 20);
        }, 220);
      }, duration + 20);
    }
    previous.addEventListener('click', () => change(-1));
    next.addEventListener('click', () => change(1));
    cards.forEach(card => card.querySelectorAll('img').forEach(image => { image.loading = 'eager'; }));
    render(); mirrorDoors();
    track.append(view);
    nativeParts.forEach(element => { element.inert = true; });
    section.classList.add('ak-showcase-active');
    document.dispatchEvent(new Event('ak:carousel-covers-added'));
    const observer = new MutationObserver(mirrorDoors);
    if (originalCover) observer.observe(originalCover, {attributes:true, attributeFilter:['class']});
    const stopRotation = window.AKTransparentRotation.mount(view);
    section._akShowcase = () => {
      disposed = true; ++exploreGeneration; clearExploreReveal(); timers.forEach(clearTimeout); observer.disconnect();
      stopRotation(); view.remove();
      nativeParts.forEach((element, i) => { element.inert = originalInert[i]; });
      exploreClasses.forEach((name, i) => section.classList.toggle(name, originalExploreClasses[i]));
      section.classList.remove('ak-showcase-active'); delete section._akShowcase;
      if (originalCoverRunning === undefined) delete section.dataset.akCoverRunning;
      else section.dataset.akCoverRunning = originalCoverRunning;
      document.dispatchEvent(new Event('ak:carousel-covers-added'));
    };
  }
  function sync() {
    document.querySelectorAll('[data-ak-home-showcase]').forEach(section => {
      if (media.matches) mount(section); else section._akShowcase?.();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  media.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
})();
